import script from "./SegmentControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./SegmentControl.vue?vue&type=script&setup=true&lang=ts"

import "./SegmentControl.vue?vue&type=style&index=0&id=4fa4eac5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fa4eac5"]])

export default __exports__